import { useEffect } from "react"
// eslint-disable-next-line instead-of/no-rxjs-catch-error
import type { Subscription } from "rxjs"
import { EMPTY, catchError, of } from "rxjs"
import { delay, switchMap } from "rxjs/operators"
import { callcenterSocket } from "@callcenter/api"
import { AuthServiceInstance, HttpService } from "@callcenter/services"

const CHECK_URL = "/check.json"
const CHECK_DELAY = 1000

const backToHomePage = (): void => {
  window.location.href = "/"
}

export const subscribeAgentCommands = (): (() => void) => {
  const subscriptions: Array<Subscription> = []
  const logout$ = callcenterSocket.AgentChannel.logout

  subscriptions.push(
    logout$
      .pipe(
        delay(CHECK_DELAY),
        switchMap(() =>
          HttpService.get(CHECK_URL).pipe(
            switchMap(() => EMPTY),
            catchError(() => of(null))
          )
        )
      )
      .subscribe(backToHomePage)
  )

  subscriptions.push(callcenterSocket.AgentChannel.forceLogout.subscribe(() => AuthServiceInstance.logout()))

  return () => subscriptions.forEach((subscription) => subscription.unsubscribe())
}

export const useAgentCommands = (): void => {
  useEffect(() => subscribeAgentCommands(), [])
}
